import React from 'react';
import { Link } from 'react-router-dom';
import img7black from '../../assets/images/img7black.png'
import Fade from 'react-reveal/Fade';
import img3 from '../../assets/images/jon.jpeg';
import '../../assets/css/Button.css';
import '../../assets/css/Appointment.css';

class Appintment extends React.Component {
    componentDidMount() {
        document.title = "Appointment";
    }
    render() {
        return (
            <>
                <div className='apptContainer' style={{}}>
                    <div style={{ justifyContent: 'center' }} >
                        <h1 className='apptTitle' style={{ paddingTop: '60px', paddingBottom: '10px' }}>Set Up an Appointment</h1>
                    </div>
                    <div className='embedContainer'>
                        <embed width='100%' height='100%' src="https://calendly.com/jongladden4thepeople/30min?month=2022-07"></embed>
                    </div>
                </div>
            </>
        )
    }
}
export default Appintment;
